export default __webpack_public_path__ + "static/media/home-image.9a120027.svg";